/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompleteUploadDto } from '../../models/complete-upload-dto';
import { MatchVideoModelDto } from '../../models/match-video-model-dto';

export interface MatchVideoControllerCompleteUpload$Params {
  uuid: string;
      body: CompleteUploadDto
}

export function matchVideoControllerCompleteUpload(http: HttpClient, rootUrl: string, params: MatchVideoControllerCompleteUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchVideoModelDto>> {
  const rb = new RequestBuilder(rootUrl, matchVideoControllerCompleteUpload.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MatchVideoModelDto>;
    })
  );
}

matchVideoControllerCompleteUpload.PATH = '/match-videos/{uuid}/upload/complete';
